<template>
	<div>
		<LightboxBase class="trailer" :close="close">
			<iframe width="100%" height="100%" :src="url" frameborder="0" allowfullscreen></iframe>
		</LightboxBase>
	</div>
</template>

<script>
import LightboxBase from './LightboxBase.vue'

export default {
	components: { LightboxBase },
	computed: {
		url: function () {
			return `https://www.youtube.com/embed/${this.$store.state.trailer}`
		},
		close: function () {
			return function () { this.$store.commit('trailer', null) }
		}
	}
}
</script>

<style lang=less>
	html.lightbox--active.lightbox--active-trailer {
		#lightbox.trailer { max-width: 100%; max-height: 100%; }
	}
	#lightbox.trailer {
		.lightbox {
			&__content { height: 80vh; }
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/lightbox/LightboxTrailer.vue